import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { AnalysisType } from 'src/app/analysis/models/AnalysisType';
import {
    selectCriterionBarItems,
    selectIsNotEditMode,
    selectIsTemplateAnalysis,
    selectSelectedAnalysisPage,
    selectTypeOfAnalysis
} from 'src/app/analysis/state/analysis.selectors';
import { AppFeature } from 'src/app/core/app-feature/app-feature';
import { selectAppFeatures } from 'src/app/core/state/core.selectors';
import { Criterion } from '../../../analysis/models/criterions/Criterion';
import { NavigationService } from '../../services/navigation/navigation.service';
import { AnalysisPage } from '../../../analysis/models/AnalysisPage';

@Component({
    selector: 'sera-old-footer-bar-criterion',
    templateUrl: './sera-old-footer-bar-criterion.component.html',
    styleUrls: ['./sera-old-footer-bar-criterion.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraOldFooterBarCriterionComponent {
    selectedAnalysisPage: AnalysisPage | null = null;
    isTemplateAnalysis: boolean = false;
    isReadMode: boolean = false;
    analysisType: AnalysisType | undefined;
    appFeatures: AppFeature[] | null = null;

    $isTemplateAnalysis = this.store.select(selectIsTemplateAnalysis).pipe(tap(isTemplateAnalysis => (this.isTemplateAnalysis = isTemplateAnalysis)));
    $isReadMode = this.store.select(selectIsNotEditMode).pipe(tap(readMode => (this.isReadMode = readMode)));
    $selectTypeOfAnalysis = this.store.select(selectTypeOfAnalysis).pipe(tap(analysisType => (this.analysisType = analysisType)));
    $selectedAnalysisPage = this.store.select(selectSelectedAnalysisPage).pipe(
        tap(selectedCriterion => {
            this.selectedAnalysisPage = selectedCriterion;
        })
    );

    $selectAppFeatures = this.store.select(selectAppFeatures).pipe(tap(appFeatures => (this.appFeatures = appFeatures)));

    $criterionBarItems = this.store.select(selectCriterionBarItems);

    constructor(private readonly store: Store, private readonly navigateService: NavigationService, private readonly route: ActivatedRoute) {}

    navigateCriterion(criterion: Criterion) {
        this.navigateService.navigateToCriterion(
            criterion,
            this.selectedAnalysisPage!,
            this.isReadMode,
            this.isTemplateAnalysis,
            this.analysisType,
            this.appFeatures,
            this.route
        );
    }
}
